import { render } from "./DataConsent.vue?vue&type=template&id=0799d09b"
import script from "./DataConsent.vue?vue&type=script&lang=js"
export * from "./DataConsent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__